module.exports = __webpack_public_path__ + "img/login.c5b01297.png";